import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useForm } from 'react-hook-form';
import { Alert, Col, FormGroup, Button } from 'reactstrap';
import { GatewayApi } from '../../gatewayApi';
import { sleep } from '../../utils';
import { arrToObjForFieldArr } from './utils';

// Migrated from redux-form to react-hook-form. Only `operation` is edited here; the
// rest of the operation (request/response/settings/enabled/interfaceType) rides
// through from defaultValues, which react-hook-form keeps even for unregistered
// fields. The old `state.form.*` init guard becomes an initialValues check.
function IntegrationsOperationsSendForm({
  currentStore,
  currentGatewayStore,
  storeIntegration,
  storeIntegrationOperation,
  initialValues,
}) {
  const navigate = useNavigate();
  const [message, setMessage] = useState('');
  const [error, setError] = useState(false);

  const { register, handleSubmit, reset } = useForm({ defaultValues: initialValues || {} });

  const initKey = JSON.stringify(initialValues);
  useEffect(() => {
    if (initialValues) reset(initialValues);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [initKey]);

  const submit = async (store) => {
    try {
      const settings = {};
      if (store.settings) {
        store.settings.forEach((item) => {
          settings[item.name] = item.value;
        });
      }

      let dataRequest = {},
        dataResponse = {};
      {
        let { parameters, headers, ...request } = store.request;
        dataRequest = {
          parameters: arrToObjForFieldArr(parameters),
          headers: arrToObjForFieldArr(headers),
          ...request,
        };
      }
      {
        let { parameters, headers, ...response } = store.response;
        dataResponse = {
          parameters: arrToObjForFieldArr(parameters),
          headers: arrToObjForFieldArr(headers),
          ...response,
        };
      }

      const data = {
        enabled: store.enabled,
        storeId: currentGatewayStore.storeId,
        integration: storeIntegration.integration,
        interface: storeIntegration.interface.interface,
        interfaceType: store.interfaceType,
        operation: store.operation,
        override: true,
        product: storeIntegration.interface.product,
        provider: storeIntegration.interface.provider,
        version: storeIntegration.interface.version,
        request: dataRequest,
        response: dataResponse,
        settings,
      };

      await GatewayApi.saveStoreIntegrationOperation(
        currentGatewayStore.storeId,
        storeIntegration.integration,
        storeIntegrationOperation.operation,
        data
      );
      setMessage('Saved successfully');
      setError(false);
      await sleep(1000);
      navigate(`/stores/${currentStore.id}/gateway/integrations/${storeIntegration.integration}`);
    } catch (err) {
      console.error('error:', err);
      setMessage('Failed to save, reason: ' + err.message);
      setError(true);
    }

    return false;
  };

  const onCancel = () => {
    navigate(-1);
  };

  if (!storeIntegration || !initialValues) {
    return <>Loading...</>;
  }

  return (
    <>
      <form onSubmit={handleSubmit(submit)} className="form-horizontal">
        {message && <Alert color={error ? 'danger' : 'success'}>{message}</Alert>}
        <FormGroup row>
          <Col sm={12}>
            <textarea
              {...register('operation')}
              className={'form-control'}
              style={{ height: '200px' }}
              id="operation"
              required
            />
          </Col>
        </FormGroup>
        <div className="float-end">
          <Button type="button" color="secondary" className="me-2" onClick={() => onCancel()}>
            Cancel
          </Button>
          <Button type="submit" color="primary">
            Save
          </Button>
        </div>
        <div style={{ clear: 'both' }}></div>
        <div style={{ marginTop: 5 }}>{message && <Alert color={error ? 'danger' : 'success'}>{message}</Alert>}</div>
      </form>
    </>
  );
}

export default IntegrationsOperationsSendForm;
